import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { IgniteLoadingIndicator } from '@kar-dmp/pattern-library/react';
import { LoadingIndicatorVariant } from '@kar-dmp/pattern-library';
import useEscModalTracking from '../../../_shared/hooks/useEscModalTracking';
import BaseModal from '../../../_shared/components/BaseModal';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

import {
  StyledDiv,
  StyledLoadingIndicator,
  StyledTransportIcon,
  CloseButton,
  CloseIcon
} from './Styles';
import useTermsAndConditions from '../../../_shared/hooks/useTermsAndConditions';

const propTypes = {
  data: PropTypes.shape({
    termsAndConditions: PropTypes.shape({
      title: PropTypes.string,
      heading: PropTypes.string,
      message: PropTypes.string,
      disclaimer: PropTypes.string
    })
  }).isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

const TransportModal = ({
  closeModal,
  data,
  dealerId,
  isMultiOrgAndEnabled,
  modalIsOpen,
  tradeId
}) => {
  const isOmp = isOmpPlatform();

  useEscModalTracking('VDP-rate-info', modalIsOpen);

  const { data: termsAndConditions, isFetching } = useTermsAndConditions({
    dealerId,
    isMultiOrgAndEnabled,
    modalIsOpen,
    shippingEstimateResponse: data,
    tradeId
  });

  return (
    <BaseModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      padding="0px"
      width=""
      hasParentSelector={isOmp}
      testId="vdp-transport-info-modal"
    >
      <StyledDiv isOmp={isOmp} isFetching={isFetching}>
        <div className="header">
          <CloseButton onClick={closeModal}>
            {/* CLOSE */}
            <FormattedMessage id="vdp.close" />
            <CloseIcon />
          </CloseButton>
          {isFetching ? (
            <StyledLoadingIndicator>
              <IgniteLoadingIndicator
                data-testid="loader"
                visible
                variant={LoadingIndicatorVariant.Circle}
              />
            </StyledLoadingIndicator>
          ) : (
            <>
              {termsAndConditions?.isShippingPromotion ? (
                <>
                  <div className="header-title-promo">
                    <StyledTransportIcon />
                    {termsAndConditions?.heading}
                  </div>
                </>
              ) : (
                <div
                  className="header-title"
                  /* eslint-disable-next-line */
                  dangerouslySetInnerHTML={{
                    __html: termsAndConditions?.heading
                  }}
                />
              )}
              <div className="content-1">
                <div
                  /* eslint-disable-next-line */
                  dangerouslySetInnerHTML={{
                    __html: termsAndConditions?.title
                  }}
                />
                <hr className="line" />
                <div
                  className="message"
                  /* eslint-disable-next-line */
                  dangerouslySetInnerHTML={{
                    __html: termsAndConditions?.message
                  }}
                />
              </div>
              <hr className="line" />
              <div
                className="content-2"
                /* eslint-disable-next-line */
                dangerouslySetInnerHTML={{
                  __html: termsAndConditions?.disclaimer
                }}
              />
            </>
          )}
        </div>
      </StyledDiv>
    </BaseModal>
  );
};

TransportModal.propTypes = propTypes;

export default TransportModal;
